import { EndOfJourneyQuestionnaire } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentEndOfJourneyQuestionnaire(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-questionnaires'].get.url, { id: enrollmentId }))
    .get<EndOfJourneyQuestionnaire>()
}
